module.exports = __webpack_public_path__ + "img/ru.96a0ee26.svg";